export const RebateTierCode = Object.freeze({
  NONE: 'NONE',
  BASE_TIER: 'BASE_TIER',
  TIER_1: 'TIER_1',
  TIER_2: 'TIER_2',
  TIER_3: 'TIER_3',
});

export const RebateTierDisplayWithoutIncomeBrackets = Object.freeze({
  NONE: 'None',
  BASE_TIER: 'Base Tier',
  TIER_1: 'Tier 1',
  TIER_2: 'Tier 2',
  TIER_3: 'Tier 3',
});

export const RebateEventStatusFlexCodes = Object.freeze({
  INITIAL: 'INITIAL',
  NEW: 'NEW',
  SENT: 'SENT',
  REGISTRATION_ACCEPTED: 'REGISTRATION ACCEPTED',
  REJECTED: 'REJECTED',
  WITHDRAWAL_ACCEPTED: 'WITHDRAWAL ACCEPTED',
  CLAIM_ACCEPTED: 'CLAIM ACCEPTED',
});

export const RebateEventTypesFlexCodes = Object.freeze({
  APPLICANT_REGISTRATION: 'R',
  SWITCH_APPLICANT: 'S',
  CHANGE_APPLICATION_PERIOD: 'C',
  APPLICANT_WITHDRAWAL: 'W',
});